export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
export const SET_LOADER = "SET_LOADER";
export const SET_ENABLE = "SET_ENABLE";
